import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/AuthContext";
import { UserURL } from "../../routes/user_routes/UserURL";
import LoadingSpinner from "../loaders/LoadingSpinner";
// import "../../css/components/page_wrappers/UserPageWrapper.css";
import "../../css/components/page_wrappers/UserPageHeader.css";

const Header = () => {
    const navigate = useNavigate();
    const { logout, user, authLoading } = useAuth();
    if (authLoading) return <LoadingSpinner />;
    if (!user) return null;
    const initials = user?.user_full_name?.split(" ").map(word => word[0]).join("").slice(0, 2).toUpperCase();

    return (
        <header className="header">
            {/* LEFT */}
            <div className="header-left">
                <div className="logo">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor"
                        strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                    >
                        <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z"/>
                    </svg>
                    <span>InvoiceFlow</span>
                </div>

                <nav className="nav">
                    <button className="nav-item active" onClick={() => navigate(UserURL.USER_DASHBOARD)}>Dashboard</button>
                    <button className="nav-item">Settings</button>
                </nav>
            </div>

            {/* RIGHT */}
            <div className="header-right">
                <div className="search-box">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m21 21-4.34-4.34"/><circle cx="11" cy="11" r="8"/></svg>
                    </span>
                    <input placeholder="Search..." />
                </div>

                <div className="icon-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M10.268 21a2 2 0 0 0 3.464 0"/><path d="M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326"/></svg>
                </div>

                <div className="profile">
                    <div className="avatar">{initials}</div>
                    <span>{user?.user_full_name}</span>
                    <span className="dropdown">▾</span>
                    <div className="profile-menu">
                        <button
                            className="profile-menu-item"
                            onClick={() => navigate(UserURL.USER_DASHBOARD)}
                        >
                            Edit Profile
                        </button>
                        <button className="profile-menu-item logout" onClick={logout}>
                            Logout
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

const Footer = () => {
    return (
        <>
            <footer>
                <p>This is the footer content.</p>
            </footer>
        </>
    );
};

const UsersPageWrapper = ({ children }) => {
    return (
        <>
            <Header />
            {children}
            <Footer />
        </>
    );
};

export default UsersPageWrapper;
